export enum ValidationTypes {
  STRING = "string",
  ARRAY = "array",
  OBJECT = "object",
  ARRAY_BUFFER = "ArrayBuffer",
}
